import Maybe from 'true-myth/maybe';

import type { Customization } from '~/shared/customization/customization';
import type { Id } from '~/shared/data-contract/id';

type CustomizationState = {
    readonly assumedTenantId: Maybe<Id>;
    readonly customization: Maybe<Customization>;
    readonly isDefaultCustomization: boolean;
};

type CustomizationStateApi = {
    readonly get: <K extends keyof CustomizationState>(key: K) => CustomizationState[K];
    readonly reset: () => void;
    readonly update: (stateToUpdate: Partial<CustomizationState>) => void;
};

export const createCustomizationState = (): CustomizationStateApi => {
    const initialState: CustomizationState = {
        assumedTenantId: Maybe.nothing(),
        customization: Maybe.nothing(),
        isDefaultCustomization: true,
    };

    let state: CustomizationState = { ...initialState };

    const update = (stateToUpdate: Partial<CustomizationState>): void => {
        state = {
            ...state,
            ...stateToUpdate,
        };
    };

    return {
        get(key) {
            return state[key];
        },
        reset() {
            update(initialState);
        },
        update,
    };
};
